import { render, staticRenderFns } from "./InteractiveConsole.vue?vue&type=template&id=08a46c1f&scoped=true"
import script from "./InteractiveConsole.vue?vue&type=script&lang=ts"
export * from "./InteractiveConsole.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a46c1f",
  null
  
)

export default component.exports